import React from "react";
// MUI
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ButtonContained } from "components/button/CommonButton";
import TextField from "@mui/material/TextField";
import DateRangePicker from "@mui/lab/DateRangePicker";
import AdapterDayjs from "@mui/lab/AdapterDayjs";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
// Recoil
import { useRecoilState } from "recoil";
import { defaultGenerateReportProps, generateReportProps } from "recoil/atom";
// Hook
import { timeOptions, transactionTypes, useGenerateReports } from "hooks/useGenerateReports";
import dayjs from "dayjs";

const GenerateReports = () => {
  const [props, setProps] = useRecoilState(generateReportProps);
  const {
    time,
    type,
    onChangeTime,
    onChangeType,
    value,
    setValue,
    isChooseCustom,
    onGenerateReport,
    loading,
  } = useGenerateReports();

  const onCancel = () => {
    setProps(defaultGenerateReportProps);
  };

  return (
    <Dialog open={props.visible} onClose={onCancel} sx={{ "& .MuiPaper-root": { width: 480 } }}>
      <DialogTitle sx={{ textAlign: "center" }}>
        Generate transaction report
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Divider sx={{ mb: 3 }} />
        <div className="flex flex-col items-center gap-3">
          <Typography variant="body1" sx={{ color: "text.secondary", textAlign: "center", mb: 2 }}>
            Customize and export a file containing your account data. You can use this data for
            accounting purposes and analysis.
          </Typography>
          <Select fullWidth sx={{ height: 40 }} value={time} onChange={onChangeTime}>
            {timeOptions.map((item) => (
              <MenuItem value={item.value} key={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          <Select fullWidth sx={{ height: 40 }} value={type} onChange={onChangeType}>
            {transactionTypes.map((item) => (
              <MenuItem value={item.value} key={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>

          {isChooseCustom && (
            <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ width: "100%" }}>
              <DateRangePicker
                startText=""
                endText=""
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                maxDate={dayjs()}
                renderInput={(startProps, endProps) => (
                  <React.Fragment>
                    <TextField
                      {...startProps}
                      sx={{ "& .MuiOutlinedInput-input": { height: 10 } }}
                    />
                    <Box sx={{ mx: 2 }}> to </Box>
                    <TextField {...endProps} sx={{ "& .MuiOutlinedInput-input": { height: 10 } }} />
                  </React.Fragment>
                )}
              />
            </LocalizationProvider>
          )}
          <ButtonContained
            fullWidth
            sx={{ height: 45, mt: 2 }}
            onClick={onGenerateReport}
            loading={loading}
          >
            Generate report
          </ButtonContained>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GenerateReports;
